import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {useSelector} from 'react-redux';

function CheckToken (props) {
    
    const history = useNavigate();
    const auth = useSelector(state => state.auth)
    useEffect(() => {
        if (auth.loading) return;
        if (auth.isAuthenticated === false) {
            history('/logout');
        }
    },[auth.loading, auth.isAuthenticated, history]);

    return (
        null
    )
}
export default CheckToken;
